export default "__VITE_ASSET__Bpgk3HLZ__"